import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=40bdccd6"
import script from "./receiving.vue?vue&type=script&lang=js"
export * from "./receiving.vue?vue&type=script&lang=js"
import style0 from "./receiving.vue?vue&type=style&index=0&id=40bdccd6&prod&lang=scss&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports